<template>
  <div class="Login-container" v-if="loginVisible">
      <div class="content">
        <img class="logo" src="../../assets/images/手机端/域贝可视化带框.png" alt="">
        <van-icon name="cross" size="1rem" class="icon" @click="Out()"/>
        <div class="title">
          欢迎登录域贝可视化
        </div>
        <div class="form">
            <input type="text" class="one" v-model="username" placeholder="请输入手机号" onKeyUp="value=value.replace(/[\W]/g,'')">
          <div class="two">
            <input type="text" v-model="code" placeholder="请输入验证码" onKeyUp="value=value.replace(/[\W]/g,'')">
            <span class="val" @click="onSendCode">{{ sendTime ? time : '获取验证码' }} </span>
          </div>
          <button @click="Sign">登录/注册</button>
        </div>
      </div>
    </div>
</template>

<script>
import {sendCode, loginByCode} from '@/api/price'
export default {
  props: {
    loginVisible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // 是否显示
      // loginVisible:false,
      //手机号
      username: '',
      //验证码模块
      code: '',
      sendCode: false,
      time: 60,
      sendTime: false,

      
      

      


    };
  },
  watch: {
        // eslint-disable-next-line object-shorthand
        sendTime: function () {
            if (this.sendTime) {
                let timer = setInterval(() => {
                    if (this.time > 1) {
                        this.time--
                    } else {
                        this.sendTime = false
                        this.time = 60
                        clearInterval(timer)
                    }
                }, 1000);
            }
        }
    },
  methods: {
    //退出
    Out(){
      this.$emit("close");
    },
    //验证码模块
    async onSendCode() {
      console.log(this.username);
      if (this.username===''){
        // Message.error("请输入手机号");
        this.$dialog.alert({
            message: '请输入手机号',
              }).then(() => {
                  // on close
                  });
        return
      }
      if (this.username && (/^1[3456789]\d{9}$/.test(this.username))) {
        this.sendTime = true;
        let res = await sendCode(
          { number: this.username },
        );
        if (res.code === 1) {
          // this.$message({
          //   message: "验证码发送成功",
          //   type: "success",
          //   customClass: 'global-messageZindex'
          // });
          this.$dialog.alert({
            message: '验证码发送成功',
              }).then(() => {
                  // on close
                  });
        } else {
          // this.$message({
          //   message: res.msg,
          //   type: "error",
          // });
          this.$dialog.alert({
            message: res.msg,
              }).then(() => {
                  // on close
                  });
        }
      } else {
        // this.$message({
        //   message: '手机号格式不正确',
        //   type: 'error'
        // })
          this.$dialog.alert({
            message: '手机号格式不正确',
              }).then(() => {
                  // on close
                  });
        return
      }
    },
    //登录模块
    async Sign() {
      if (this.username === '') {
        // this.$message({
        //   message: '请输入手机号',
        //   type: 'error'
        // })
        this.$dialog.alert({
            message: '请输入手机号',
              }).then(() => {
                  // on close
                  });
        return
      }
      // 校验手机号
      if (!(/^1[3456789]\d{9}$/.test(this.username))) {
        // this.$message({
        //   message: '手机号格式不正确',
        //   type: 'error'
        // })
        this.$dialog.alert({
            message: '手机号格式不正确',
              }).then(() => {
                  // on close
                  });
        return
      }
      if (this.code === '') {
        // this.$message({
        //   message: '请输入验证码',
        //   type: 'error'
        // })
        this.$dialog.alert({
            message: '请输入验证码',
              }).then(() => {
                  // on close
                  });
        return
      }

      const res = await loginByCode({ mobile: this.username, code: this.code })
      this.messg(res);

    },
    // token模块
    messg(res) {
      if (res.code === 1) {
        localStorage.setItem("token", res.payload);
        this.$emit("close");
        this.$emit("showLink");
        // this.$message({
        //   message: '恭喜你，登录成功',
        //   type: 'success'
        // });
        // this.$dialog.alert({
        //     message: '恭喜你，登录成功',
        //       }).then(() => {
        //           // on close
        //           });
        this.username = "";
        this.code = "";
      } else {
        // this.$message({
        //   message: res.msg,
        //   type: "error",
        //   customClass: 'global-messageZindex'
        // })
        this.$dialog.alert({
            message: 'res.msg',
              }).then(() => {
                  // on close
                  });
      }
    },
  }
}
</script>

<style lang="less" scoped>
.Login-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  touch-action: none;
  pointer-events: auto;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.8);
  z-index: 2000;
  .content{
    position: relative;
    margin-top: calc(395rem/50);
    padding: 0 calc(36rem/50);
    width: calc(646rem/50);
    height: calc(692rem/50);
    background: #FCFCFC;
    border-radius: 24px;
    .logo {
      margin-top: calc(42rem/50);
      height: calc(59rem/50);
      margin-bottom: calc(77rem/50);
    }
    .icon {
      position: absolute;
      top: .5rem;
      right: .5rem;
    }
    .title {
      font-size: calc(36rem/50);
      margin-bottom: calc(40rem/50);
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .form {
      font-size: calc(28rem/50);
      font-family: PingFang SC;
      font-weight: 400;
    .one {
      border: calc(1rem/50) solid #8A94A9;
      height: calc(85rem/50);
      width: 100%;
      margin-bottom: calc(27rem/50);
      color: #000000;
      padding-left: calc(24rem/50);
    }
    .two {
      position: relative;
      height: calc(85rem/50);
      width: 100%;
      color: #9EAFC9;
      margin-bottom: calc(39rem/50);
      input {
        height: 100%;
        width: 100%;
        border: calc(1rem/50) solid #8A94A9;
        padding-left: calc(24rem/50);
      }
      span {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        line-height: calc(85rem/50);
        margin-right: calc(27rem/50);
        color: #008EF2;
      }
    }
    button {
      width: 100%;
      height: calc(84rem/50);
      background: #567EFF;
      box-shadow: calc(3rem/50) calc(5rem/50) calc(7rem/50) 0px rgba(57,86,165,0.3);
      border-radius: calc(4rem/50);
      color: #FFFFFF;
      outline: none;
      border: none;
    }
    }
}
.global-messageZindex {
  z-index:99999999992 !important;
}
}
</style>